import React, {
  lazy,
  Suspense,
  useEffect,
  type FC,
  type PropsWithChildren,
} from 'react'
import {isMobileUserAgent} from 'services/app'
import {initSDK} from 'src/yandexSDK'
import {useGetAdaptiveStyle} from 'uikit'
import {useAppDispatch, useAppSelector} from 'store'
import {IMGPIXID} from 'src/consts'
import {adaptiveConfigMarginTop} from 'src/common/components/GamePage/consts'
import {isLoading} from 'store/game/selectors'
import {setLoadGame, setGameLoaded} from 'store/game/slice'
import {getTranslatesThunk} from 'store/translates/thunk'
import {initAnsweredIdsThunk} from 'store/game/thunk'
import {PageLoader} from 'src/common/components/PageLoader'
import {PreventPullToRefresh} from '../PreventPullToRefresh'
import pix from '../../img/pix.png'
import Header from './Header'
import styles from './gallowgamelayout.scss'


const ModalContainer = lazy(() => import('src/desktop/components/ModalContainer')
  .then(({ ModalContainer }) => ({ default: ModalContainer })))

const BottomSheetContainer = lazy(() => import('src/mobile/components/BottomSheetContainer')
  .then(({ BottomSheetContainer }) => ({ default: BottomSheetContainer })))

export const GallowGameLayout: FC<PropsWithChildren> = ({children}) => {
  const {style} = useGetAdaptiveStyle([adaptiveConfigMarginTop])
  const dispatch = useAppDispatch()
  const isLoadingGame = useAppSelector(isLoading)

  useEffect(() => {
    const initGame = async () => {
      dispatch(setLoadGame())
      if (YSDK) {
        const s = document.createElement('script');
        s.src = '/sdk.js';
        s.async = true;
        s.onload = initSDK;
        document.body.append(s);
      } else {
        dispatch(getTranslatesThunk())
        dispatch(initAnsweredIdsThunk())
        dispatch(setGameLoaded())
      }
    }

    initGame()
  }, [])

  const isMobile = isMobileUserAgent()

  return (
    <Suspense>
      <PreventPullToRefresh>
        <img id={IMGPIXID} src={pix} />
        <div className={styles.wrap} style={!isMobile ? style : {}}>
          <Header />
          {isLoadingGame
            ? <PageLoader />
            : children
          }
          {isMobile ? <BottomSheetContainer /> : <ModalContainer />}
        </div>
      </PreventPullToRefresh>
    </Suspense>
  )
}
